import { Container, Row, Col } from "react-bootstrap";
import "./jumbotron.css";

const Jumbotron = () => {
  return (
    <div>
      <Container className="JumboBG" fluid>
        <Row>
          <Col>&nbsp;</Col>
        </Row>
      </Container>
    </div>
  );
};

export default Jumbotron;
